import "./App.css";
import { useState, useRef } from "react";
import "./assets/css/card.css";
import VisitingCard from "./component/eventcards/VisitingCard";
import ExhibitingCard from "./component/eventcards/ExhibitingCard";
import ExhibitinginWomenPCard from "./component/eventcards/ExhibitinginWomenPCard";
import "./assets/css/cardPrint.css";
import { IoIosPrint } from "react-icons/io";
import { toJpeg } from "html-to-image";
import EventCard from "./component/eventcards/EventCard";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';

function App() {
  const [option, setOption] = useState("VISITING");
  const [image, setImage] = useState(null);
  const [name, setName] = useState("");
  const [formData, setFormData] = useState({
    stallNo: "",
    domeNo: "",
    companyName: "",
    phone:""
  });
  const [previewImage, setPreviewImage] = useState(null); // For image preview

  const handleChange = (event) => {
    const { name, value } = event?.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleimageChange=(e)=>{
    const {type, files } = e.target;
    
    if (type === "file" && files[0]) {
      const file = files[0];
    
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewImage(reader.result); // Base64 URL
      };
      reader.readAsDataURL(file);
    } 
  }

  const [error, setError] = useState({
    name:"",
    image:""
  });


  const cardRef = useRef(); // Reference to the visiting card container

  const handleDownload = () => {
    let formIsValid = true;
  
    if (!formData.stallNo) {
      setError((prevState) => ({
        ...prevState,
        stallNo: "Please enter stall number.",
      }));
      formIsValid = false;
      window.alert("Please enter stall number.");
    }
  
    // Validate domeNo
    if (!formData.domeNo) {
      setError((prevState) => ({
        ...prevState,
        domeNo: "Please enter dome number.",
      }));
      formIsValid = false;
      window.alert("Please enter dome number.");
    }
  
    // Validate companyName
    if (!formData.companyName) {
      setError((prevState) => ({
        ...prevState,
        companyName: "Please enter company name.",
      }));
      formIsValid = false;
      window.alert("Please enter company name.");
    }
  
    if (!formData.phone) {
      setError((prevState) => ({
        ...prevState,
        phone: "Please enter mobile number.",
      }));
      formIsValid = false;
      window.alert("Please enter mobile number.");
    }

    // Validate previewImage
    if (!previewImage) {
      setError((prevState) => ({
        ...prevState,
        image: "Please upload an image.",
      }));
      formIsValid = false;
      window.alert("Please upload an image.");
    }
  
 

    if (formIsValid) {
      const deleteIcons = cardRef.current.querySelectorAll(".deleteIcon");
      deleteIcons.forEach((icon) => icon.classList.add("hidden-during-download"));

    if (cardRef.current) {
      toJpeg(cardRef.current, { quality: 0.95 })
        .then((dataUrl) => {
          const link = document.createElement("a");
          link.href = dataUrl;
          link.download = `${option}-card.jpg`; // Dynamic filename based on option
          link.click();
          window.location.reload();
        })
        .catch((error) => {
          console.error("Failed to generate image:", error);
        });
    }
   }
  };

  const handlePrint = () => {
    let formIsValid = true;
    setError({
      name: "",
      image: ""
    });
    if (option === "VISITING") {
      if (!image) {
        setError(prevState => ({ ...prevState, image: "Please upload an image before printing." }));
        formIsValid = false;
      }
    } else {
      if (!name) {
        setError(prevState => ({ ...prevState, name: "Please enter your name before printing." }));
        formIsValid = false;
      }
      if (!image) {
        setError(prevState => ({ ...prevState, image: "Please upload an image before printing." }));
        formIsValid = false;
      }
    }

    if (formIsValid) {
    const printContent = cardRef.current; 
    const originalContent = document.body.innerHTML; 
    document.body.innerHTML = printContent.outerHTML;
    window.print(); 
    document.body.innerHTML = originalContent;
    window.location.reload();
    }
  };

  const handlePhoneNoChange = (value, country) => {
    const phoneNum = value?.slice(2);
    const country_code = `${country.format.charAt(0)}${country?.dialCode}`;
    const phone = `${country_code}${phoneNum}`;
    setFormData({
      ...formData,
      phone: phone,
    });
  };

  return (
    <div>
      <div className="background-style">
        <div className=" flex justify-center items-center md:gap-6 dropdown-section px-5">
           
           <button
            className="text-white mt-10 md:mt-10 ml-4 bg-blue-500 p-2 rounded"
            onClick={handleDownload}>
            Download
          </button>
        </div>
         
       <div className="flex flex-col md:flex-row justify-center">  
        <div className="flex justify-center items-center gap-3 md:gap-6 dropdown-section px-5 mt-3">
        
        <div>
          <input
            className="company-name-input"
            type="text"
            name="domeNo"
            placeholder="Enter Dome No."
            value={formData.domeNo}
            onChange={handleChange}
            maxLength={15}
          />
        </div>
        
        <div>
          <input
            className="company-name-input"
            type="text"
            name="stallNo"
            placeholder="Enter Stall No."
            value={formData.stallNo}
            onChange={handleChange}
            maxLength={15}
          />
        </div>

       
        </div>

        <div className="flex justify-center items-center gap-3 md:gap-6 dropdown-section px-5 mt-3">
        <div>
          <input
            className="company-name-input"
            type="text"
            name="companyName"
            placeholder="Enter Company Name"
            value={formData.companyName}
            onChange={handleChange}
            maxLength={50}
          />
        </div>

        <div>
        <PhoneInput
          className=""
          inputClass="company-name-input"
          country={"in"}
          value={formData?.mobile}
          onChange={handlePhoneNoChange}
        />
        </div>
        </div>

        <div className="flex justify-center items-center gap-3 md:gap-6 dropdown-section px-5 mt-3"> 
         <input
            type="file"
            className="company-name-input text-white"
            accept="image/*"
            name="file"
            onChange={handleimageChange}
          />
        </div>
        </div>

         <div className="mt-3" ref={cardRef}>
          <EventCard image={previewImage} setPreviewImage={setPreviewImage} formData={formData}/>
         </div>
   
      </div>
    </div>
  );
}

export default App;
